/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "weather_testing";

export enum WeatherTestingConditionType {
  ALWAYS = 0,
  FLIGHT_AND_LANDING = 1,
  TAKEOFF = 2,
  UNRECOGNIZED = -1,
}

export function weatherTestingConditionTypeFromJSON(object: any): WeatherTestingConditionType {
  switch (object) {
    case 0:
    case "ALWAYS":
      return WeatherTestingConditionType.ALWAYS;
    case 1:
    case "FLIGHT_AND_LANDING":
      return WeatherTestingConditionType.FLIGHT_AND_LANDING;
    case 2:
    case "TAKEOFF":
      return WeatherTestingConditionType.TAKEOFF;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WeatherTestingConditionType.UNRECOGNIZED;
  }
}

export function weatherTestingConditionTypeToJSON(object: WeatherTestingConditionType): string {
  switch (object) {
    case WeatherTestingConditionType.ALWAYS:
      return "ALWAYS";
    case WeatherTestingConditionType.FLIGHT_AND_LANDING:
      return "FLIGHT_AND_LANDING";
    case WeatherTestingConditionType.TAKEOFF:
      return "TAKEOFF";
    case WeatherTestingConditionType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface WindWallCommand {
  utime: number;
  command: WindWallCommand_WindWallCommandType;
  condition: WeatherTestingConditionType;
  baseWind: number;
  vonKarmanHeightAboveGround: number;
  flightId: string;
  nonce: number;
}

export enum WindWallCommand_WindWallCommandType {
  STOP = 0,
  CONSTANT = 1,
  VON_KARMAN = 2,
  UNRECOGNIZED = -1,
}

export function windWallCommand_WindWallCommandTypeFromJSON(object: any): WindWallCommand_WindWallCommandType {
  switch (object) {
    case 0:
    case "STOP":
      return WindWallCommand_WindWallCommandType.STOP;
    case 1:
    case "CONSTANT":
      return WindWallCommand_WindWallCommandType.CONSTANT;
    case 2:
    case "VON_KARMAN":
      return WindWallCommand_WindWallCommandType.VON_KARMAN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WindWallCommand_WindWallCommandType.UNRECOGNIZED;
  }
}

export function windWallCommand_WindWallCommandTypeToJSON(object: WindWallCommand_WindWallCommandType): string {
  switch (object) {
    case WindWallCommand_WindWallCommandType.STOP:
      return "STOP";
    case WindWallCommand_WindWallCommandType.CONSTANT:
      return "CONSTANT";
    case WindWallCommand_WindWallCommandType.VON_KARMAN:
      return "VON_KARMAN";
    case WindWallCommand_WindWallCommandType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface WindWallWind {
  utime: number;
  wind: number;
  executingCommand: WindWallCommand | undefined;
}

export interface RainRigCommand {
  utime: number;
  command: RainRigCommand_RainRigCommandType;
  condition: WeatherTestingConditionType;
  flightId: string;
  nonce: number;
}

export enum RainRigCommand_RainRigCommandType {
  NONE = 0,
  LIGHT = 1,
  HEAVY = 2,
  UNRECOGNIZED = -1,
}

export function rainRigCommand_RainRigCommandTypeFromJSON(object: any): RainRigCommand_RainRigCommandType {
  switch (object) {
    case 0:
    case "NONE":
      return RainRigCommand_RainRigCommandType.NONE;
    case 1:
    case "LIGHT":
      return RainRigCommand_RainRigCommandType.LIGHT;
    case 2:
    case "HEAVY":
      return RainRigCommand_RainRigCommandType.HEAVY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RainRigCommand_RainRigCommandType.UNRECOGNIZED;
  }
}

export function rainRigCommand_RainRigCommandTypeToJSON(object: RainRigCommand_RainRigCommandType): string {
  switch (object) {
    case RainRigCommand_RainRigCommandType.NONE:
      return "NONE";
    case RainRigCommand_RainRigCommandType.LIGHT:
      return "LIGHT";
    case RainRigCommand_RainRigCommandType.HEAVY:
      return "HEAVY";
    case RainRigCommand_RainRigCommandType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface RainRigRain {
  utime: number;
  actualRain: RainRigCommand_RainRigCommandType;
  executingCommand: RainRigCommand | undefined;
}

export interface TurntableCommand {
  utime: number;
  command: TurntableCommand_TurntableCommandType;
  /** [deg] */
  targetAngle: number;
  flightId: string;
  nonce: number;
}

export enum TurntableCommand_TurntableCommandType {
  INVALID = 0,
  STOP = 1,
  GOTO = 2,
  UNRECOGNIZED = -1,
}

export function turntableCommand_TurntableCommandTypeFromJSON(object: any): TurntableCommand_TurntableCommandType {
  switch (object) {
    case 0:
    case "INVALID":
      return TurntableCommand_TurntableCommandType.INVALID;
    case 1:
    case "STOP":
      return TurntableCommand_TurntableCommandType.STOP;
    case 2:
    case "GOTO":
      return TurntableCommand_TurntableCommandType.GOTO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TurntableCommand_TurntableCommandType.UNRECOGNIZED;
  }
}

export function turntableCommand_TurntableCommandTypeToJSON(object: TurntableCommand_TurntableCommandType): string {
  switch (object) {
    case TurntableCommand_TurntableCommandType.INVALID:
      return "INVALID";
    case TurntableCommand_TurntableCommandType.STOP:
      return "STOP";
    case TurntableCommand_TurntableCommandType.GOTO:
      return "GOTO";
    case TurntableCommand_TurntableCommandType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface TurntableStatus {
  utime: number;
  status: TurntableStatus_TurntableStatusType;
  /** [deg] */
  angle: number;
  /** [deg] */
  targetAngle: number;
}

export enum TurntableStatus_TurntableStatusType {
  INVALID = 0,
  STOPPED_MOTION = 1,
  MOVING_TO_TARGET = 2,
  AT_TARGET = 3,
  IDLE = 4,
  AUTO_ALIGNED = 5,
  UNRECOGNIZED = -1,
}

export function turntableStatus_TurntableStatusTypeFromJSON(object: any): TurntableStatus_TurntableStatusType {
  switch (object) {
    case 0:
    case "INVALID":
      return TurntableStatus_TurntableStatusType.INVALID;
    case 1:
    case "STOPPED_MOTION":
      return TurntableStatus_TurntableStatusType.STOPPED_MOTION;
    case 2:
    case "MOVING_TO_TARGET":
      return TurntableStatus_TurntableStatusType.MOVING_TO_TARGET;
    case 3:
    case "AT_TARGET":
      return TurntableStatus_TurntableStatusType.AT_TARGET;
    case 4:
    case "IDLE":
      return TurntableStatus_TurntableStatusType.IDLE;
    case 5:
    case "AUTO_ALIGNED":
      return TurntableStatus_TurntableStatusType.AUTO_ALIGNED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TurntableStatus_TurntableStatusType.UNRECOGNIZED;
  }
}

export function turntableStatus_TurntableStatusTypeToJSON(object: TurntableStatus_TurntableStatusType): string {
  switch (object) {
    case TurntableStatus_TurntableStatusType.INVALID:
      return "INVALID";
    case TurntableStatus_TurntableStatusType.STOPPED_MOTION:
      return "STOPPED_MOTION";
    case TurntableStatus_TurntableStatusType.MOVING_TO_TARGET:
      return "MOVING_TO_TARGET";
    case TurntableStatus_TurntableStatusType.AT_TARGET:
      return "AT_TARGET";
    case TurntableStatus_TurntableStatusType.IDLE:
      return "IDLE";
    case TurntableStatus_TurntableStatusType.AUTO_ALIGNED:
      return "AUTO_ALIGNED";
    case TurntableStatus_TurntableStatusType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseWindWallCommand(): WindWallCommand {
  return { utime: 0, command: 0, condition: 0, baseWind: 0, vonKarmanHeightAboveGround: 0, flightId: "", nonce: 0 };
}

export const WindWallCommand = {
  encode(message: WindWallCommand, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).uint64(message.utime);
    }
    if (message.command !== 0) {
      writer.uint32(16).int32(message.command);
    }
    if (message.condition !== 0) {
      writer.uint32(24).int32(message.condition);
    }
    if (message.baseWind !== 0) {
      writer.uint32(33).double(message.baseWind);
    }
    if (message.vonKarmanHeightAboveGround !== 0) {
      writer.uint32(41).double(message.vonKarmanHeightAboveGround);
    }
    if (message.flightId !== "") {
      writer.uint32(50).string(message.flightId);
    }
    if (message.nonce !== 0) {
      writer.uint32(56).uint64(message.nonce);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WindWallCommand {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWindWallCommand();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.uint64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.command = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.condition = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.baseWind = reader.double();
          continue;
        case 5:
          if (tag !== 41) {
            break;
          }

          message.vonKarmanHeightAboveGround = reader.double();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.flightId = reader.string();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.nonce = longToNumber(reader.uint64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WindWallCommand {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      command: isSet(object.command) ? windWallCommand_WindWallCommandTypeFromJSON(object.command) : 0,
      condition: isSet(object.condition) ? weatherTestingConditionTypeFromJSON(object.condition) : 0,
      baseWind: isSet(object.baseWind) ? globalThis.Number(object.baseWind) : 0,
      vonKarmanHeightAboveGround: isSet(object.vonKarmanHeightAboveGround)
        ? globalThis.Number(object.vonKarmanHeightAboveGround)
        : 0,
      flightId: isSet(object.flightId) ? globalThis.String(object.flightId) : "",
      nonce: isSet(object.nonce) ? globalThis.Number(object.nonce) : 0,
    };
  },

  toJSON(message: WindWallCommand): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.command !== 0) {
      obj.command = windWallCommand_WindWallCommandTypeToJSON(message.command);
    }
    if (message.condition !== 0) {
      obj.condition = weatherTestingConditionTypeToJSON(message.condition);
    }
    if (message.baseWind !== 0) {
      obj.baseWind = message.baseWind;
    }
    if (message.vonKarmanHeightAboveGround !== 0) {
      obj.vonKarmanHeightAboveGround = message.vonKarmanHeightAboveGround;
    }
    if (message.flightId !== "") {
      obj.flightId = message.flightId;
    }
    if (message.nonce !== 0) {
      obj.nonce = Math.round(message.nonce);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WindWallCommand>, I>>(base?: I): WindWallCommand {
    return WindWallCommand.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WindWallCommand>, I>>(object: I): WindWallCommand {
    const message = createBaseWindWallCommand();
    message.utime = object.utime ?? 0;
    message.command = object.command ?? 0;
    message.condition = object.condition ?? 0;
    message.baseWind = object.baseWind ?? 0;
    message.vonKarmanHeightAboveGround = object.vonKarmanHeightAboveGround ?? 0;
    message.flightId = object.flightId ?? "";
    message.nonce = object.nonce ?? 0;
    return message;
  },
};

function createBaseWindWallWind(): WindWallWind {
  return { utime: 0, wind: 0, executingCommand: undefined };
}

export const WindWallWind = {
  encode(message: WindWallWind, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).uint64(message.utime);
    }
    if (message.wind !== 0) {
      writer.uint32(17).double(message.wind);
    }
    if (message.executingCommand !== undefined) {
      WindWallCommand.encode(message.executingCommand, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WindWallWind {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWindWallWind();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.uint64() as Long);
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.wind = reader.double();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.executingCommand = WindWallCommand.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WindWallWind {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      wind: isSet(object.wind) ? globalThis.Number(object.wind) : 0,
      executingCommand: isSet(object.executingCommand) ? WindWallCommand.fromJSON(object.executingCommand) : undefined,
    };
  },

  toJSON(message: WindWallWind): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.wind !== 0) {
      obj.wind = message.wind;
    }
    if (message.executingCommand !== undefined) {
      obj.executingCommand = WindWallCommand.toJSON(message.executingCommand);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WindWallWind>, I>>(base?: I): WindWallWind {
    return WindWallWind.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WindWallWind>, I>>(object: I): WindWallWind {
    const message = createBaseWindWallWind();
    message.utime = object.utime ?? 0;
    message.wind = object.wind ?? 0;
    message.executingCommand = (object.executingCommand !== undefined && object.executingCommand !== null)
      ? WindWallCommand.fromPartial(object.executingCommand)
      : undefined;
    return message;
  },
};

function createBaseRainRigCommand(): RainRigCommand {
  return { utime: 0, command: 0, condition: 0, flightId: "", nonce: 0 };
}

export const RainRigCommand = {
  encode(message: RainRigCommand, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).uint64(message.utime);
    }
    if (message.command !== 0) {
      writer.uint32(16).int32(message.command);
    }
    if (message.condition !== 0) {
      writer.uint32(24).int32(message.condition);
    }
    if (message.flightId !== "") {
      writer.uint32(34).string(message.flightId);
    }
    if (message.nonce !== 0) {
      writer.uint32(40).uint64(message.nonce);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RainRigCommand {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRainRigCommand();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.uint64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.command = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.condition = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.flightId = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.nonce = longToNumber(reader.uint64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RainRigCommand {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      command: isSet(object.command) ? rainRigCommand_RainRigCommandTypeFromJSON(object.command) : 0,
      condition: isSet(object.condition) ? weatherTestingConditionTypeFromJSON(object.condition) : 0,
      flightId: isSet(object.flightId) ? globalThis.String(object.flightId) : "",
      nonce: isSet(object.nonce) ? globalThis.Number(object.nonce) : 0,
    };
  },

  toJSON(message: RainRigCommand): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.command !== 0) {
      obj.command = rainRigCommand_RainRigCommandTypeToJSON(message.command);
    }
    if (message.condition !== 0) {
      obj.condition = weatherTestingConditionTypeToJSON(message.condition);
    }
    if (message.flightId !== "") {
      obj.flightId = message.flightId;
    }
    if (message.nonce !== 0) {
      obj.nonce = Math.round(message.nonce);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RainRigCommand>, I>>(base?: I): RainRigCommand {
    return RainRigCommand.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RainRigCommand>, I>>(object: I): RainRigCommand {
    const message = createBaseRainRigCommand();
    message.utime = object.utime ?? 0;
    message.command = object.command ?? 0;
    message.condition = object.condition ?? 0;
    message.flightId = object.flightId ?? "";
    message.nonce = object.nonce ?? 0;
    return message;
  },
};

function createBaseRainRigRain(): RainRigRain {
  return { utime: 0, actualRain: 0, executingCommand: undefined };
}

export const RainRigRain = {
  encode(message: RainRigRain, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.actualRain !== 0) {
      writer.uint32(16).int32(message.actualRain);
    }
    if (message.executingCommand !== undefined) {
      RainRigCommand.encode(message.executingCommand, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RainRigRain {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRainRigRain();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.actualRain = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.executingCommand = RainRigCommand.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RainRigRain {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      actualRain: isSet(object.actualRain) ? rainRigCommand_RainRigCommandTypeFromJSON(object.actualRain) : 0,
      executingCommand: isSet(object.executingCommand) ? RainRigCommand.fromJSON(object.executingCommand) : undefined,
    };
  },

  toJSON(message: RainRigRain): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.actualRain !== 0) {
      obj.actualRain = rainRigCommand_RainRigCommandTypeToJSON(message.actualRain);
    }
    if (message.executingCommand !== undefined) {
      obj.executingCommand = RainRigCommand.toJSON(message.executingCommand);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RainRigRain>, I>>(base?: I): RainRigRain {
    return RainRigRain.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RainRigRain>, I>>(object: I): RainRigRain {
    const message = createBaseRainRigRain();
    message.utime = object.utime ?? 0;
    message.actualRain = object.actualRain ?? 0;
    message.executingCommand = (object.executingCommand !== undefined && object.executingCommand !== null)
      ? RainRigCommand.fromPartial(object.executingCommand)
      : undefined;
    return message;
  },
};

function createBaseTurntableCommand(): TurntableCommand {
  return { utime: 0, command: 0, targetAngle: 0, flightId: "", nonce: 0 };
}

export const TurntableCommand = {
  encode(message: TurntableCommand, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.command !== 0) {
      writer.uint32(16).int32(message.command);
    }
    if (message.targetAngle !== 0) {
      writer.uint32(33).double(message.targetAngle);
    }
    if (message.flightId !== "") {
      writer.uint32(42).string(message.flightId);
    }
    if (message.nonce !== 0) {
      writer.uint32(48).uint64(message.nonce);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TurntableCommand {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTurntableCommand();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.command = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.targetAngle = reader.double();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.flightId = reader.string();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.nonce = longToNumber(reader.uint64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TurntableCommand {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      command: isSet(object.command) ? turntableCommand_TurntableCommandTypeFromJSON(object.command) : 0,
      targetAngle: isSet(object.targetAngle) ? globalThis.Number(object.targetAngle) : 0,
      flightId: isSet(object.flightId) ? globalThis.String(object.flightId) : "",
      nonce: isSet(object.nonce) ? globalThis.Number(object.nonce) : 0,
    };
  },

  toJSON(message: TurntableCommand): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.command !== 0) {
      obj.command = turntableCommand_TurntableCommandTypeToJSON(message.command);
    }
    if (message.targetAngle !== 0) {
      obj.targetAngle = message.targetAngle;
    }
    if (message.flightId !== "") {
      obj.flightId = message.flightId;
    }
    if (message.nonce !== 0) {
      obj.nonce = Math.round(message.nonce);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TurntableCommand>, I>>(base?: I): TurntableCommand {
    return TurntableCommand.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TurntableCommand>, I>>(object: I): TurntableCommand {
    const message = createBaseTurntableCommand();
    message.utime = object.utime ?? 0;
    message.command = object.command ?? 0;
    message.targetAngle = object.targetAngle ?? 0;
    message.flightId = object.flightId ?? "";
    message.nonce = object.nonce ?? 0;
    return message;
  },
};

function createBaseTurntableStatus(): TurntableStatus {
  return { utime: 0, status: 0, angle: 0, targetAngle: 0 };
}

export const TurntableStatus = {
  encode(message: TurntableStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    if (message.angle !== 0) {
      writer.uint32(25).double(message.angle);
    }
    if (message.targetAngle !== 0) {
      writer.uint32(33).double(message.targetAngle);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TurntableStatus {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTurntableStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 25) {
            break;
          }

          message.angle = reader.double();
          continue;
        case 4:
          if (tag !== 33) {
            break;
          }

          message.targetAngle = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TurntableStatus {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      status: isSet(object.status) ? turntableStatus_TurntableStatusTypeFromJSON(object.status) : 0,
      angle: isSet(object.angle) ? globalThis.Number(object.angle) : 0,
      targetAngle: isSet(object.targetAngle) ? globalThis.Number(object.targetAngle) : 0,
    };
  },

  toJSON(message: TurntableStatus): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.status !== 0) {
      obj.status = turntableStatus_TurntableStatusTypeToJSON(message.status);
    }
    if (message.angle !== 0) {
      obj.angle = message.angle;
    }
    if (message.targetAngle !== 0) {
      obj.targetAngle = message.targetAngle;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TurntableStatus>, I>>(base?: I): TurntableStatus {
    return TurntableStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TurntableStatus>, I>>(object: I): TurntableStatus {
    const message = createBaseTurntableStatus();
    message.utime = object.utime ?? 0;
    message.status = object.status ?? 0;
    message.angle = object.angle ?? 0;
    message.targetAngle = object.targetAngle ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
